module.exports = __webpack_public_path__ + "static/media/2.4d36d498.png";